import { Notification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { handleNotificationPressAction } from '@/features/notifications/thunks/handleNotificationPressAction'
import { useAppDispatch } from '@/hooks/redux'

export const useNotificationPressAction = (notification: Notification): (() => void) => {
    const dispatch = useAppDispatch()

    return () => {
        dispatch(handleNotificationPressAction(notification))
    }
}
